'use strict';

import { view } from '@/functions';

const prefix = '/';

export default [
    { 
        path: prefix, 
        redirect: '/home'
    },
    { 
        path: `${prefix}login`, 
        name: 'login',
        component: () => view('main/login'),
        meta: {
            layout: 'Blank',
            title: 'Login',
        } 
    },
    { 
        path: `${prefix}update-password`, 
        name: 'update-password',
        component: () => view('main/update-password'),
        meta: {
            layout: 'Blank',
            title: 'Update password',
        } 
    },
    { 
        path: `${prefix}recovery-password`, 
        name: 'recovery-password',
        component: () => view('main/recovery-password'),
        meta: {
            layout: 'Blank',
            title: 'Recovery password',
        } 
    },
    {
        path: `${prefix}expired-password`,
        name: 'expired-password',
        component: () => view('main/expirePassword'),
        meta: {
            layout: 'Blank',
            title: 'Expired password',
        } 
    }
];
